import { applyMiddleware, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import ReduxThunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { intakeMiddleware } from 'modules/intake/intake.middleware';
// eslint-disable-next-line import/no-cycle
import appReducer from './reducers';
import { history } from '../functions/history';
import { googleAnalytics } from './middlewares/reactGAMiddlewares';
import { popupCloserMiddleware } from './middlewares/popupCloserMiddleware';
import userConstants from '../components/Authentication/constants'; // defaults to localStorage for web and AsyncStorage for react-native
import configs from '../configs';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [],
  blacklist: ['router'],
};

const rootReducer = (state, action) => {
  let nextState = state;
  if (action.type === userConstants.LOGOUT) {
    nextState = undefined;
    storage.removeItem('persist:root');
  }
  return appReducer(nextState, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
// const loggerMiddleware = createLogger();
const middleware = [ReduxThunk, routerMiddleware(history), popupCloserMiddleware, intakeMiddleware];

if (!configs.isProduction) {
  // middleware.push(loggerMiddleware);
}
if (configs.isProduction || configs.gaTrackingCode) {
  // add google Analytics in Production
  middleware.push(googleAnalytics);
}
if (!configs.isProduction && configs.isReduxLoggerEnabled) {
  middleware.push(createLogger());
}

// If production, disable trace
const composeEnhancer = composeWithDevTools({
  trace: !configs.isProduction,
  traceLimit: 25,
});

export const store = createStore(
  persistedReducer,
  configs.isProduction ? applyMiddleware(...middleware) : composeEnhancer(applyMiddleware(...middleware)),
);
export const persistor = persistStore(store);
